module.exports = __webpack_public_path__ + "img/gift_open.3288d20f.gif";